import { create } from "zustand";

/*
 * Ugly state synchronisation to keep track of the busy state of the Web assembly code.
 * Rather not have this, but it is hard to discern between empty and loading state otherwise.
 */
export const useKnopIsLoading = create<{
  isLoading: boolean;
  setLoading: () => void;
  setReady: () => void;
}>((set) => ({
  isLoading: false,
  setLoading: () => set({ isLoading: true }),
  setReady: () => set({ isLoading: false }),
}));
